
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 4.037H5.75A1.752 1.752 0 0 0 4 5.787v20.5a1.752 1.752 0 0 0 1.75 1.75h20.5a1.752 1.752 0 0 0 1.75-1.75v-20.5a1.752 1.752 0 0 0-1.75-1.75Zm.25 1.75v2.897l-3.148-3.147h2.898a.25.25 0 0 1 .25.25Zm-3.31 1.708-4.597 4.596-6.554-6.554h9.192l1.958 1.958Zm1.06 1.06 2.25 2.25v9.193l-6.846-6.846 4.596-4.596ZM5.75 5.538h4.168l1.958 1.958-4.597 4.596L5.5 10.312V5.787a.25.25 0 0 1 .25-.25Zm2.59 18.929 4.596-4.597 6.668 6.668H10.41l-2.07-2.071Zm-1.06-1.061-1.78-1.78v-9.192l6.376 6.376-4.597 4.596ZM5.5 26.287v-2.54l2.79 2.79H5.75a.25.25 0 0 1-.25-.25Zm20.75.25h-4.525L8.34 13.152l4.597-4.596L26.5 22.119v4.168a.25.25 0 0 1-.25.25Z"}})])
          )
        }
      }
    